<template lang="pug">
  .footer__container
    .footer__content
      .footer__copyright 2019
        a.footer__copyright-link(
          href="https://lifehacker.ru/"
          target="_blank"
        ) {{` Лайфхакер`}}
    .footer__image
      img(
        src="../../assets/voron.png"
      )
</template>

<script>
export default {
  name: 'TheFooter',
};
</script>

<style lang="scss" scoped>
  .footer__container {
    width: 100%;
    height: 72px;
    background-color: #000000;
    align-items: center;
    position: relative;

    margin-top: 250px;

    @include mobile {
      height: 78px;
      margin-top: 100px;
    }
  }

  .footer__content {
    max-width: 1200px;
    min-width: 320px;
    height: 72px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    align-items: center;
    position: relative;

    @include tablet {
      margin-left: 16px;
    }

    @include mobile {
      height: 100%;
      margin-left: 20px;
    }
  }

  .footer__copyright {
    opacity: 0.87;
    font-family: Roboto;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: 0.25px;
    color: #ffffff;
  }

  .footer__copyright-link {
    color: inherit;
  }

  .footer__image {
    width: 368px;
    height: 308px;
    position: absolute;
    bottom: 2px;
    left: calc(50% - 184px);


    @include mobile {
      width: 144px;
      height: 120px;
      left: calc(50% - 72px);
      bottom: 53px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/common/TheFooter.vue